import { createApp } from 'vue'
import App           from "./components/App.vue";
import store         from "./store";

function onReady ()
{

    const comments = document.querySelectorAll( '.comments-section' );

    if ( comments.length === 0 )
    {
        console.info('💬 No comments container element. No need for the comments module.')
        return;
    }


    Array.from( comments ).forEach( ( el, i ) =>
    {

        // console.log('el.dataset', el.dataset);

        const vueComments = createApp( App );
        vueComments
            .provide( 'commentsPostType', el.dataset.postType )
            .provide( 'commentsPostId', parseInt( el.dataset.postId ) )
            .provide( 'reactionsOnly', 'true' === el.dataset.reactionsOnly )
            .provide( 'startClosed', 'true' === el.dataset.startClosed )
            .provide( 'loadingText', el.dataset.loadingText )
            .provide( 'audienceMode', el.dataset.audienceMode )
            .provide( 'doLiveRefresh', el.dataset.doLiveRefresh ?? 1 )
            .provide( 'liveRefreshFrequency', el.dataset.liveRefreshFrequency ?? 30 )
            .provide( 'mixDate', __VITE_COMPILATION_DATE__ )
            .use( store )
            .mount( el )
    } );
}


// document.addEventListener( 'DOMContentLoaded', onReady );
onReady();
// console.log( 'comments.js is in da house' );
